import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useParams,
  useLocation,
} from "react-router-dom";
import { useBreadcrumb, BreadcrumbProvider, AuthController } from "$components";
import * as Page from "$containers";
import { makeLinks } from "$components/Breadcrumb/Breadcrumbs";

function HomeOrConnexion() {
  const user = localStorage.getItem("authState");
  if (!user || !JSON.parse(user)?.user) return <Page.Connexion />;
  return <Page.Projects />;
}

function PrivateRouteElement({
  Component,
  matchPath,
}: {
  Component: any;
  matchPath: string;
}) {
  const { links } = useBreadcrumb();
  const params = useParams();
  const location = useLocation();
  const hasAccess = links.find((l) => l.path === matchPath)?.hasAccess ?? true;

  if (!hasAccess) {
    return <Page.Forbidden />;
  }

  const user = localStorage.getItem("authState");
  const isLoggedIn = !!(user && JSON.parse(user)?.user);

  const routerProps = {
    match: { params, path: matchPath, url: location.pathname },
    location,
  };

  return (
    <BreadcrumbProvider routerProps={routerProps}>
      {isLoggedIn ? <Component /> : <Page.Connexion />}
    </BreadcrumbProvider>
  );
}

// Route statique construite une fois au chargement du module — hasAccess
// n'est pas résolu ici (voir PrivateRouteElement), ces prédicats bouchon
// ne servent qu'à extraire path/component depuis makeLinks().
const staticLinks = makeLinks({
  isAdmin: () => false,
  isClient: () => false,
  isContributor: () => false,
});

const createEdbLink = staticLinks.find((l) => l.path === "/create-edb/:idEdb?");

const router = createBrowserRouter([
  {
    element: (
      <BreadcrumbProvider>
        <AuthController />
        <Outlet />
      </BreadcrumbProvider>
    ),
    children: [
      { path: "/", element: <HomeOrConnexion /> },
      { path: "/mot-de-passe", element: <Page.Recovery /> },
      { path: "/succes", element: <Page.Succes /> },
      { path: "/connexion", element: <HomeOrConnexion /> },
      { path: "/dossier-expedition/:id", element: <Page.ShippingPublic /> },
      // split de l'ancien "/create-edb/:idEdb?" (syntaxe optionnelle non
      // reprise telle quelle en v7)
      {
        path: "/create-edb",
        element: (
          <PrivateRouteElement
            Component={createEdbLink.component}
            matchPath="/create-edb/:idEdb?"
          />
        ),
      },
      {
        path: "/create-edb/:idEdb",
        element: (
          <PrivateRouteElement
            Component={createEdbLink.component}
            matchPath="/create-edb/:idEdb?"
          />
        ),
      },
      ...staticLinks
        .filter((l) => l.path !== "/create-edb/:idEdb?")
        .map(({ path, component: Component }) => ({
          path,
          element: (
            <PrivateRouteElement Component={Component} matchPath={path} />
          ),
        })),
    ],
  },
]);

export { router };

export default function Router() {
  return <RouterProvider router={router} />;
}
